import { defineMessages } from "react-intl"

// Global / Shared messages should go here
export const messages = defineMessages({
  welcome: {
    id: "app.welcome",
    defaultMessage: "Explore and share thousands of {siteName} photos and other items."
  },
  featuredCollections: {
    id: "title.featured-collections",
    defaultMessage: "Featured Collections"
  },
  communitySets: {
    id: "title.communtiy-sets",
    defaultMessage: "Community Sets"
  },
  numberOfItems: {
    id: "items.number-of",
    defaultMessage: "{count} {count, plural, one {item} other {items}}"
  },
  numberOfItemsE: {
    id: "items.number-of-e",
    defaultMessage: "{count} {count, plural, one {item} other {items}}"
  },
  address: {
    id: "shared.address",
    defaultMessage: "4 The Square, Palmerston North, 4410"
  },
  findTwitter: {
    id: "social.find-twitter",
    defaultMessage: "Find us on Twitter"
  },
  findFacebook: {
    id: "social.find-facebook",
    defaultMessage: "Find us on Facebook"
  },
  findInstagram: {
    id: "social.find-instagram",
    defaultMessage: "Find us on Instagram"
  },
  findEmail: {
    id: "social.find-email",
    defaultMessage: "Email us"
  },
  somethingWentWrong: {
    id: "error.something-went-wrong",
    defaultMessage: "Something went wrong."
  },
  emailDefault: {
    id: "profile.email-default",
    defaultMessage: "Email *"
  },
  email: {
    id: "email",
    defaultMessage: "Email"
  },
  passwordDefault: {
    id: "profile.password-default",
    defaultMessage: "Password *"
  },
  enterTitle: {
    id: "upload.enter-title",
    defaultMessage: "Please enter a title for this {type}"
  },
  enterDescription: {
    id: "upload.enter-description",
    defaultMessage: "Please enter a brief description for this {type}"
  },
  noImage: {
    id: "upload.no-image",
    defaultMessage: "You haven't uploaded an {type}"
  },
  noLicense: {
    id: "upload.no-license",
    defaultMessage: "Please specify a license for this {type}"
  },
  buttonDone: {
    id: "button.done",
    defaultMessage: "Done"
  },
  buttonLogIn: {
    id: "button.log-in",
    defaultMessage: "Log in"
  },
  buttonDiscardChanges: {
    id: "button.discard-changes",
    defaultMessage: "Discard changes"
  },
  buttonUploadFile: {
    id: "button.upload-file",
    defaultMessage: "Upload {type} file"
  },
  buttonSaveChanges: {
    id: "button.save-changes",
    defaultMessage: "Save changes"
  },
  formMessagePleaseWait: {
    id: "form.message-please-wait",
    defaultMessage: "Please wait while your file uploads."
  },
  formTitle: {
    id: "form.title",
    defaultMessage: "Title"
  },
  formDescription: {
    id: "form.description",
    defaultMessage: "Description"
  },
  formTags: {
    id: "form.tags",
    defaultMessage: "Tags"
  },
  communityTags: {
    id: "tags.communityTags",
    defaultMessage: "Community Tags"
  },
  formTagsHelp: {
    id: "form.tags-help",
    defaultMessage:
      "Separate tags with a comma, e.g. My Tag, My Second Tag, Third, Etc"
  },
  formCreator: {
    id: "form.creator",
    defaultMessage: "Creator"
  },
  formCreatorHelp: {
    id: "form.creator-help",
    defaultMessage: "The name of the person who created this {type}."
  },
  formLicenseReuse: {
    id: "form.license-reuse",
    defaultMessage: "Allow this {type} to be reused under the {license}"
  },
  formDate: {
    id: "form.date",
    defaultMessage: "Date"
  },
  formLocation: {
    id: "form.location",
    defaultMessage: "Location"
  },
  formLicense: {
    id: "form.license",
    defaultMessage: "License"
  },
  formLicenseOutOfCopyright: {
    id: "form.license-out-of-copyright",
    defaultMessage: "This {type} is out of copyright"
  },
  formResetPassword: {
    id: "form.reset-your-password",
    defaultMessage: "Reset your password"
  },
  edtfDateInstructions: {
    id: "edtf.date-instructions",
    defaultMessage: "Please use EDTF Date Format. For example, if you only know year and month use YYYY-MM. <a href=\"https://support.stqry.com/hc/en-us/articles/360001175695-EDTF-Dates\" target=\"_blank\">See More Examples</a>."
  },
  taxonomy: {
    id: "tag.taxonomy",
    defaultMessage: "Taxonomy"
  },
  loadMoreItems: {
    id: "results.load-more-items",
    defaultMessage: "Load More Items"
  },
  cantFindPage: {
    id: "shared.cant-find-page",
    defaultMessage: "Sorry we can’t find the page you’ve requested"
  },
  backToCollections: {
    id: "collections.back-to-collections",
    defaultMessage: "Back to all Collections"
  },
  typeImage: { id: "type.image", defaultMessage: "Image" },
  typeMedia: { id: "type.media", defaultMessage: "Media" },
  typeAudio: { id: "type.audio", defaultMessage: "Audio" },
  typeVideo: { id: "type.video", defaultMessage: "Video" },
  typePhotoAlbum: { id: "type.photo_album", defaultMessage: "Photo Album" },
  typeBook: { id: "type.book", defaultMessage: "Book" },
  typePostCard: { id: "type.postcard", defaultMessage: "Postcard" },
  typeDiary: { id: "type.diary", defaultMessage: "Diary" },
  typeBoundVolume: { id: "type.bound_volume", defaultMessage: "Bound Volume" },
  typeArticle: { id: "type.article", defaultMessage: "Article" },
  typeCorrespondence: {
    id: "type.correspondence",
    defaultMessage: "Correspondence"
  },
  typeMultiPage: {
    id: "type.multi_page",
    defaultMessage: "Multi-Page Document"
  },
  typeMap: { id: "type.map", defaultMessage: "Map" },
  typeObject: { id: "type.object", defaultMessage: "Physical Object" },
  typePage: { id: "type.page", defaultMessage: "Page" },
  typeObjectImage: { id: "type.object_image", defaultMessage: "Object Image" },
  typeCollection: { id: "type.collection", defaultMessage: "Collection" },
  typeUnspecified: { id: "type.unspecified", defaultMessage: "Unspecified" },
  typeSet: { id: "type.set", defaultMessage: "Set" },
  zoomIn: {
    id: "button.zoom-in",
    defaultMessage: "Zoom In"
  },
  zoomOut: {
    id: "button.zoom-out",
    defaultMessage: "Zoom Out"
  },
  mapOpacity: {
    id: "button.map-opacity",
    defaultMessage: "Map Opacity"
  },
  opacity: {
    id: "button.opacity",
    defaultMessage: "Opacity"
  },
  previousPageImage: {
    id: "button.previous-page-image",
    defaultMessage: "Previous Page/Image"
  },
  nextPageImage: {
    id: "button.next-page-image",
    defaultMessage: "Next Page/Image"
  },
  allPageImage: {
    id: "button.all-page-image",
    defaultMessage: "All Pages/Images"
  },
  tabDescription: {
    id: "tab.description",
    defaultMessage: "Description"
  },
  tabTranscript: {
    id: "tab.transcript",
    defaultMessage: "Transcript"
  },
  tabComments: {
    id: "tab.Comments",
    defaultMessage: "Comments"
  },
  moreInfo: {
    id: "moreInfo",
    defaultMessage: "More Info →"
  },
  more: {
    id: "more",
    defaultMessage: "More"
  },
  mapOpacityUp: {
    id: "button.map-opacity-up",
    defaultMessage: "Map Opacity Up"
  },
  mapOpacityDown: {
    id: "button.map-opacity-down",
    defaultMessage: "Map Opacity Down"
  },
  next: {
    id: "modal.next",
    defaultMessage: "Next"
  },
  previous: {
    id: "modal.previous",
    defaultMessage: "Previous"
  }
})

export default messages



// WEBPACK FOOTER //
// ./webapp/messages/index.js